"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayCodes = void 0;
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const contexts_1 = require("../../contexts");
const paths_1 = require("../../paths");
const utils_1 = require("../../utils");
const luxon_1 = require("luxon");
function usePayCodes({ employeeId, payPeriodBreakdownInfo, language, shouldFetch, usageLocation }) {
    const { host, clientName, currentStage } = (0, contexts_1.useTaaConfigsContext)();
    const { startTime, endTime } = getStartAndEndTimeOfPaycode(payPeriodBreakdownInfo);
    const ApiPath = (0, paths_1.GET_PAY_CODES_API)(employeeId, startTime, endTime, language);
    return (0, react_query_1.useQuery)(['payCodes', ApiPath], () => (0, fetchClient_1.getData)({
        path: ApiPath,
        host,
        eventName: utils_1.taaEvents.GET_PAY_CODES,
        metaData: {
            apiName: 'getPayCodes',
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: !!employeeId && shouldFetch && !!payPeriodBreakdownInfo,
        staleTime: 60 * 10000,
        retry: false
    });
}
exports.usePayCodes = usePayCodes;
const getStartAndEndTimeOfPaycode = (payPeriodBreakdownInfo) => {
    const startTime = luxon_1.DateTime.fromISO(payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current.start_time).toUTC();
    const endTime = luxon_1.DateTime.fromISO(payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current.end_time).toUTC();
    const diffInDays = endTime.diff(startTime, ['days']).days;
    if (diffInDays > 30) {
        return {
            startTime: startTime.toFormat(utils_1.GET_PAY_CODES_DATE_TIME_FORMAT),
            endTime: startTime
                .plus({ days: 30 })
                .toFormat(utils_1.GET_PAY_CODES_DATE_TIME_FORMAT)
        };
    }
    return {
        startTime: startTime.toFormat(utils_1.GET_PAY_CODES_DATE_TIME_FORMAT),
        endTime: endTime.toFormat(utils_1.GET_PAY_CODES_DATE_TIME_FORMAT)
    };
};
